/* eslint-disable consistent-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-bitwise */
/* eslint-disable no-nested-ternary */
import { METERS_PER_UNIT, getPointResolution } from 'ol/proj';
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style,
  Icon,
  RegularShape,
} from 'ol/style';
import moment from 'moment';

export const RED = '#EF1C29';
export const ORANGE = '#FFA927';
export const YELLOW = '#f5e600';
export const GREEN = '#1cba3d';
export const GREY = '#888888';
export const BLACK = '#000000';

export const style = [];


style.highwaycams = {
  // eslint-disable-next-line no-unused-vars
  Point(feature, resolution) {
    let cameraRotationRad = 0;
    if (typeof feature.getProperties().orientation !== 'undefined') {
      cameraRotationRad = (feature.getProperties().orientation - 90) * Math.PI / 180;
    }
    if (typeof feature.getProperties().direction !== 'undefined') {
      const orientations = [];
      orientations.N = 0;
      orientations.NE = 45;
      orientations.E = 90;
      orientations.SE = 135;
      orientations.S = 180;
      orientations.SW = 225;
      orientations.W = 270;
      orientations.NW = 315;

      cameraRotationRad = (orientations[feature.getProperties().direction] - 90) * Math.PI / 180;
    }

    return new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        anchor: [0.5, 10],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: 'static/points/traffic-camera-point.png',
        rotation: cameraRotationRad,
        rotateWithView: true,
        angle: 0,
      })),
    });
  },
};

const severityColors = {
  minor: YELLOW,
  moderate: ORANGE,
  major: RED,
  unknown: GREY,
};

style.drivebc = {
  // eslint-disable-next-line no-unused-vars
  LineString(feature, resolution) {
    const severity = feature.getProperties().severity ? feature.getProperties().severity.toLowerCase() : 'unknown';
    const severityColor = severityColors[severity];

    return new Style({
      stroke: new Stroke({
        color: severityColor,
        width: 5,
      }),
      fill: new Fill({
        color: severityColor,
      }),
    });
  },

  // eslint-disable-next-line no-unused-vars
  Point(feature, resolution) {
    const severity = feature.getProperties().severity.toLowerCase();
    const icon = new Icon(/** @type {module:ol/style/Icon~Options} */ ({
      anchor: [0.5, 10],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      src: `static/points/incident-${severity}-point.png`,
      angle: 0,
    }));
    return new Style({
      image: icon,
    });
  },
};


// eslint-disable-next-line dot-notation
style['essCenters'] = {
  // eslint-disable-next-line no-unused-vars
  Point(feature, resolution) {
    const status = feature.getProperties().STATUS;
    const type = feature.getProperties().FACILITY_TYPE_CODE;
    if (status === 'OPEN' && type === 'RC') {
      return new Style({
        image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
          anchor: [0.5, 10],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: 'static/points/shelter-point.png',
          angle: 0,
        })),
      });
    }
  },
};

// #35BE91 - open color
style['bc-recreation-open'] = {
  // eslint-disable-next-line no-unused-vars
  Point(feature, resolution) {
    const typeCode = feature.getProperties().PROJECT_TYPE.slice(0, 3).toLowerCase();

    // eslint-disable-next-line no-constant-condition
    if (typeCode === 'rtr' || 'sit' || 'if ') {
      return new Style({
        image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
          anchor: [0.5, 10],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: `static/points/${typeCode}-open-point.png`,
          angle: 0,
        })),
      });
    }

    return new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        anchor: [0.5, 10],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: 'static/points/other-open-point.png',
        angle: 0,
      })),
    });
  },

  // eslint-disable-next-line no-unused-vars
  LineString(feature, resolution) {
    const color = '#35BE91';
    return new Style({
      stroke: new Stroke({
        color,
        width: 5,
      }),
      fill: new Fill({
        color,
      }),
    });
  },
};

style['recreational-closures'] = {
  // eslint-disable-next-line no-unused-vars
  Point(feature, resolution) {
    const typeCode = feature.getProperties().PROJECT_TYPE.slice(0, 3).toLowerCase();

    // eslint-disable-next-line no-constant-condition
    if (typeCode === 'rtr' || 'sit' || 'if ') {
      return new Style({
        image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
          anchor: [0.5, 10],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: `static/points/${typeCode}-closed-point.png`,
          angle: 0,
        })),
      });
    }

    return new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        anchor: [0.5, 10],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: 'static/points/other-closed-point.png',
        angle: 0,
      })),
    });
  },
  // eslint-disable-next-line no-unused-vars
  LineString(feature, resolution) {
    const color = '#ea2a35';
    return new Style({
      stroke: new Stroke({
        color,
        width: 5,
      }),
      fill: new Fill({
        color,
      }),
    });
  },
};

style.modis = {
  // eslint-disable-next-line no-unused-vars
  Point(feature, resolution) {
    let fillColor = '#f03b20';
    const date = feature.getProperties().ACQ_DATE;
    const timeDifference = moment().diff(date, 'hours', true);

    const pointResolution = getPointResolution('EPSG:3857', 1, feature.getGeometry().getCoordinates());
    // account for variation in resolution as we move away from the equator
    const resolutionFactor = 1 / pointResolution;
    const radius = (500 * METERS_PER_UNIT.m / resolution) * resolutionFactor;
    // console.log('Radius: (500 * METERS_PER_UNIT.m / resolution) * resolutionFactor',
    //   `(500 * ${METERS_PER_UNIT.m} / ${resolution}) * ${resolutionFactor}`);

    if (timeDifference > 0) fillColor = '#f03b20';
    if (timeDifference > 12) fillColor = '#fd8d3c';
    if (timeDifference > 24) fillColor = '#fecc5c';

    return new Style({
      image: new CircleStyle({
        // radius: radius < 8 ? 8 : radius,
        radius,
        stroke: new Stroke({
          color: '#bd0026',
          width: 1.5,
        }),
        fill: new Fill({
          color: fillColor,
        }),
      }),
    });
  },
};

const fireStatusPerimeterStyles = {
  'out-of-control': {
    fill: '#BD0026',
    opacity: 1,
  },
  'fire-of-note': {
    fill: '#F03B20',
    opacity: 1,
  },
  'being-held': {
    fill: [253, 141, 60, 0.75],
    opacity: 0.75,
  },
  'under-control': {
    fill: [254, 204, 92, 0.5],
    opacity: 0.5,
  },
};

// eslint-disable-next-line no-unused-vars
function firePerimterStyle(feature, resolution) {
  const fireStatus = feature.getProperties().FIRE_STATUS.toLowerCase().replaceAll(' ', '-');
  // eslint-disable-next-line prefer-const
  const fillColor = fireStatusPerimeterStyles[fireStatus] || [96, 121, 167, 0.5]; // default
  return new Style({
    stroke: new Stroke({
      color: [255, 0, 0, fillColor.opacity],
      width: 2,
    }),
    fill: new Fill({
      color: fillColor.fill,
    }),
  });
}

style['fire-perimeters'] = {
  // eslint-disable-next-line no-unused-vars
  Polygon(feature, resolution) {
    return firePerimterStyle(feature, resolution);
  },
  MultiPolygon(feature, resolution) {
    return firePerimterStyle(feature, resolution);
  },
};

style['fire-points'] = {
  // eslint-disable-next-line no-unused-vars
  Point(feature, resolution) {
    const fireStatus = feature.getProperties().FIRE_STATUS.toLowerCase().replaceAll(' ', '-');
    return new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        anchor: [0.5, 10],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        // eslint-disable-next-line quotes
        src: `static/points/fire-${fireStatus}-point.png`,
        angle: 0,
      })),
    });
  },
};

const viirsFRP = {
  10: '#A70022',
  100: '#92001D',
  300: '#7C0019',
  750: '#670014',
  1000: '#510010',
};

const age = [
  { value: 10000, fill: '#FFFF00', opacity: 0.30 },
  { value: 24, fill: '#FFA500', opacity: 0.5 },
  { value: 12, fill: '#8B0000', opacity: 0.75 },
  { value: 6, fill: '#8B0000', opacity: 1 },
];

const ageism = {
  10000: '#FFFF00',
  24: '#FFA500',
  12: '#8B0000',
  6: '#8B0000',
  1: '#8B0000',
};

const confidenceStrokeColor = {
  l: { color: '#0dcaf0', opacity: 0.33 },
  n: { color: '#ffc107', opacity: 0.66 },
  m: { color: '#ffc107', opacity: 0.66 },
  h: { color: '#dc3545', opacity: 1 },
};

const viirsDefaultFill = [255, 193, 7, 0.75];
const viirsDefaultStroke = [220, 53, 69];

function viirsStyle(feature) {
  console.log('viirsStyle: feature', feature.getProperties());
  let opacity = 1;
  let fillColor = ageism[feature.getProperties().age] || viirsDefaultFill;
  console.log('viirsStyle: fillColor', feature.getProperties().age, fillColor);
  // eslint-disable-next-line prefer-const, no-unused-vars
  const acquisitionDateTime = new Date(`${feature.getProperties().acq_datetime} UTC`);
  const hours = (new Date().getTime() - new Date(acquisitionDateTime).getTime()) / 1000 / 60 / 60;

  if (feature.getProperties().satellite === 'modis') opacity = 0.25;

  const confidence = feature.getProperties().confidence || 'l';
  // console.log('confidence', confidence, feature.getProperties());
  const color = confidenceStrokeColor[confidence].color || viirsDefaultStroke;
  // const strokeOpacity = confidenceStrokeColor[confidence].opacity || 1;
  const strokeOpacity = 1;

  return {
    opacity,
    stroke: new Stroke({
      color,
      opacity: strokeOpacity,
      // lineDash,
      width: 2,
    }),
    fill: new Fill({
      color: fillColor,
    }),
  };
}

style.viirs = {
  // eslint-disable-next-line no-unused-vars
  Point(feature, resolution) {
    const pointResolution = getPointResolution('EPSG:3857', 1, feature.getGeometry().getCoordinates());
    // account for variation in resolution as we move away from the equator
    const resolutionFactor = 1 / pointResolution;
    // eslint-disable-next-line no-unused-vars
    const radius = (
      (feature.getProperties().diameter * 1000 / 2 || 187.5)
      * METERS_PER_UNIT.m / resolution) * resolutionFactor;

    const styleJson = viirsStyle(feature);

    return new Style({
      image: new RegularShape({
        radius,
        stroke: styleJson.stroke,
        fill: styleJson.fill,
        opacity: styleJson.opacity,
        points: 4,
        angle: Math.PI / 4,
      }),
    });
  },
  // eslint-disable-next-line no-unused-vars
  Polygon(feature, resolution) {
    return new Style(viirsStyle(feature));
  },

  MultiPolygon(feature) {
    return new Style(viirsStyle(feature));
  },
};

function getSmokeFillColor(feature) {
  const d = feature.getProperties().smoke_classdesc.trim();
  const fillColors = [];
  fillColors['0 - 3'] = [255, 255, 163, 255];
  fillColors['3 - 25'] = [250, 209, 87, 255];
  fillColors['25 - 63'] = [242, 166, 44, 255];
  fillColors['63 - 158'] = [171, 82, 19, 255];
  fillColors['158 - 1000'] = [105, 0, 0, 255];

  const fillColor = fillColors[d] || [245, 252, 210, 255];
  return new Style({
    stroke: new Stroke({
      color: [153, 52, 4, 0.5],
      width: 1,
    }),
    fill: new Fill({
      color: fillColor,
    }),
  });
}

style.ospoNoaaSmoke = {
  // eslint-disable-next-line no-unused-vars
  Polygon(feature, resolution) {
    return getSmokeFillColor(feature);
  },
  // eslint-disable-next-line no-unused-vars
  MultiPolygon(feature, resolution) {
    return getSmokeFillColor(feature);
  },
};

const avalancheCanadaStyles = {
  1: GREEN,
  2: YELLOW,
  3: ORANGE,
  4: RED,
  5: BLACK,
  6: GREY,
};

style.avalancheOrg = {
  // eslint-disable-next-line no-unused-vars
  Polygon(feature, resolution) {
    return new Style({
      stroke: new Stroke({
        color: feature.getProperties().stroke,
        width: 2,
      }),
      fill: new Fill({
        color: feature.getProperties().color,
      }),
    });
  },
  // eslint-disable-next-line no-unused-vars
  MultiPolygon(feature, resolution) {
    return new Style({
      stroke: new Stroke({
        color: feature.getProperties().stroke,
        width: 2,
      }),
      fill: new Fill({
        color: feature.getProperties().color,
      }),
    });
  },
};

function getMaxAvalanche(feature) {
  const avalancheRatings = [];
  const elevations = ['alp', 'tln', 'btl'];
  // eslint-disable-next-line no-unused-vars
  elevations.forEach((elevation, index) => {
    const rating = feature.getProperties()[elevation];
    if (rating !== undefined) {
      const ratingInt = parseInt(rating.charAt(0), 10);
      if (!isNaN(ratingInt)) {
        avalancheRatings.push(ratingInt);
      }
    }
  });

  let maxRating = Math.max.apply(null, avalancheRatings);
  if (maxRating === -Infinity) maxRating = 6;
  if (isNaN(maxRating)) maxRating = 6;
  return maxRating;
}

function shadeColor(color, percent) {
  const num = parseInt(color.slice(1), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = (num >> 8 & 0x00FF) + amt;
  const B = (num & 0x0000FF) + amt;
  return `#${(0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1)}`;
}

style.avalancheCanada = {
  // eslint-disable-next-line no-unused-vars
  Polygon(feature, resolution) {
    const fillColor = avalancheCanadaStyles[getMaxAvalanche(feature)];

    return new Style({
      stroke: new Stroke({
        color: shadeColor(fillColor, -25),
        opacity: 0.75,
        width: 2,
      }),
      fill: new Fill({
        color: fillColor,
      }),
    });
  },
  // eslint-disable-next-line no-unused-vars
  MultiPolygon(feature, resolution) {
    const fillColor = avalancheCanadaStyles[getMaxAvalanche(feature)];
    return new Style({
      stroke: new Stroke({
        color: shadeColor(fillColor, -25),
        opacity: 0.75,
        width: 2,
      }),
      fill: new Fill({
        color: fillColor,
      }),
    });
  },
};
